import {createAction, props} from '@ngrx/store';


export class BeleguebersichtActions {

  public static loadVerfuegbarkeit = createAction(
    '[Beleguebersicht] Load Verfügbarkeit der Betriebe.',
  );

  public static verfuegbarkeitLoaded = createAction(
    '[Beleguebersicht] Verfügbarkeit geladen.',
    props<{
      firmaIds: string[],
    }>(),
  );

  public static loadVerfuegbarkeitFailure = createAction(
    '[Beleguebersicht] Laden der Verfügbarkeit der Betriebe fehlgeschlagen.',
  );

  public static loadUrl = createAction(
    '[Beleguebersicht] Load Dashboard-URL.',
    props<{
      inhaberId: string,
    }>(),
  );

  public static urlLoaded = createAction(
    '[Beleguebersicht] Dashboard-URL geladen.',
    props<{
      url: string,
    }>(),
  );

  public static loadUrlFailure = createAction(
    '[Beleguebersicht] Laden der Dashboard-URL fehlgeschlagen.',
  );

  public static urlCleared = createAction(
    '[Beleguebersicht] Dashboard-URL zurückgesetzt.',
  );
}
